module.exports = __webpack_public_path__ + "img/loading1.e75660be.gif";